export enum PKUnitsImportType {
    Company = 0,
    Workplace = 1,
}
